/**
 * Action for wizard view of a reservation.
 *
 * @class
 */
Sitepackage.Plugin.Reservation.WizardAction = (function () {
    /**
     * Initializes the action.
     *
     * @param {Reservation} plugin Parent plugin
     * @param {Element} pluginContainer Parent plugin container
     * @param {Element} container Main container of the action
     *
     * @constructor
     */
    var WizardAction = function (plugin, pluginContainer, container) {
        const self = this;


        // Parent plugin
        self.plugin = plugin;

        // Parent plugin container
        self.pluginContainer = pluginContainer;

        // Main container of the action
        self.container = container;

        // Container element to show global error messages (e.g. messages of server side validation)
        self.errorContainer = document.getElementById('wizard-error-container');

        self.isInitialLoading = true;

        var alertBox = document.getElementById('modal-reservation').querySelector('.voucher-alert');
        alertBox.classList.remove('show');

        // Event listeners (not all implemented yet)
        self.listener = {
            'stepInitialized': [],
            'stepValidated': [],
            'stepCompleted': [],
            'ticketChanged': [],
            'allStepsInitialized': []
        };

        self.mode = 'new';


        /*
         * Parse initial values if it is an edit reservation modal.
         * Adjust modal title: Edit or New
         */
        var initialValues = JSON.parse(self.pluginContainer.querySelector('.values-json').innerHTML.trim());
        var modalTitle = document.getElementById('modal-reservation-title');
        if (initialValues) {
            self.mode = 'edit';
            self.setCurrentValues(initialValues);

            //Change headline of wizard from "new reservation" to "edit reservation"
            modalTitle.innerHTML = self.pluginContainer.dataset.edittitle;
        } else {
            //Change headline of wizard to "new reservation"
            modalTitle.innerHTML = self.pluginContainer.dataset.originaltitle;
        }

        modalTitle.classList.remove('d-none');

        self.container.closest('.modal-content').querySelector('.modal-footer').classList.remove('d-none');


        //Store error badge code to be used for error state of card headers
        self.errorBadgeTemplate = self.pluginContainer.querySelector('.error-badge-template').innerHTML;

        //Parse list of available tickets to be used in ticket selection
        self.products = JSON.parse(self.pluginContainer.querySelector('.products-json').innerHTML.trim());

        //Parse list of available tickets to be used in date selection
        self.timeslotTickets = JSON.parse(self.pluginContainer.querySelector('.timeslots-json').innerHTML.trim());

        self.accordion = document.getElementById('modal-reservation-steps');

        self.initializeSubmitButton();

        self.cancelButton = self.container.closest('.modal-dialog').querySelector('.btn-cancel-reservation');
        if (self.mode === 'edit') {
            self.initializeCancelButton();
        } else {
            self.cancelButton.classList.add('d-none');
        }

        //Remove loader HTML
        self.container.closest('.modal-body').querySelector('.loading-animation-container').remove();

        self.initializeSteps();
        self.initializeCollapseElements();


        self.toggleStateOfSubmitButton();

    };

    /**
     *
     * @param card
     * @returns {number}
     */
    WizardAction.prototype.getIndexOfCard = function (card) {
        var allCards = Array.prototype.slice.call(this.accordion.children);
        return allCards.indexOf(card);
    };

    WizardAction.prototype.initializeCancelButton = function () {
        const self = this;

        self.cancelButton.classList.remove('d-none');
        self.cancelButton.addEventListener('click', function (e) {

            Swal.fire({
                title: TYPO3.lang['cancelConfirmText'],
                icon: 'warning',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: TYPO3.lang['yes'],
                cancelButtonText: TYPO3.lang['no'],
                buttonsStyling: false,
                customClass: {
                    title: 'text-center',
                    confirmButton: 'btn btn-primary mr-4',
                    cancelButton: 'btn btn-outline-secondary'
                }
            }).then(function (result) {

                if (result.isConfirmed) {
                    self.cancelButton.classList.add('downloading');
                    self.errorContainer.classList.add('d-none');


                    var url = GeneralUtility.getAjaxUrl('cancel');
                    url = GeneralUtility.appendUrlParameter(url, 'reservationId', self.container.closest('.modal-body').dataset.reservationid);
                    GeneralUtility.ajaxGetRequest(url, function (data) {
                        self.cancelButton.classList.remove('downloading');
                        if (data) {
                            var response = JSON.parse(data);
                            if (response.status !== 'error') {

                                self.cancelButton.classList.add('downloaded');
                                self.cancelButton.querySelector('.trigger').classList.add('drawn');
                                setTimeout(function () {
                                    document.location.reload();
                                }, 1000);
                            } else {
                                self.showGlobalError(response.message, response.reservationId);
                            }
                        } else {
                            self.showGlobalError('Storno fehlgeschlagen');
                        }
                    });
                }
            });


        });
    };

    /**
     * Initializes the submit button events
     */
    WizardAction.prototype.initializeSubmitButton = function () {
        const self = this;

        //Disabled and enabled submit buttons are separate elements because of different markup
        self.submitButton = self.container.closest('.modal-dialog').querySelector('.btn-save-reservation-enabled');
        self.submitButtonDisabled = self.container.closest('.modal-dialog').querySelector('.btn-save-reservation-disabled');
        self.submitButton.addEventListener('click', function (e) {

            //Disable submit button to prevent multiple submits
            self.submitButton.disabled = true;

            self.submitButton.classList.add('downloading');
            self.errorContainer.classList.add('d-none');

            //Remove not existing timeslots from current values
            const currentTimeslots = self.getCurrentValue('timeslots');
            let newCurrentTimeslots = {};
            for (let timeslotArticle in currentTimeslots) {

                if (self.accordion.querySelector('.card[data-timeslot="' + timeslotArticle + '"]')) {
                    newCurrentTimeslots[timeslotArticle] = currentTimeslots[timeslotArticle];
                }
            }
            self.setCurrentValue('timeslots', newCurrentTimeslots);

            //Remove not existing variants from current values
            const currentVariants = self.getCurrentValue('variants');
            let newCurrentVariants = {};
            for (let variantId in currentVariants) {

                if (self.accordion.querySelector('input[data-id="' + variantId + '"]')) {
                    newCurrentVariants[variantId] = currentVariants[variantId];
                }
            }
            self.setCurrentValue('variants', newCurrentVariants);

            GeneralUtility.ajaxPostRequest(
                GeneralUtility.getAjaxUrl('wizard-save'),
                JSON.stringify(self.getCurrentValues()),
                'application/json',
                function (data) {
                    self.submitButton.classList.remove('downloading');
                    if (data) {
                        const response = JSON.parse(data);
                        if (response.status !== 'error') {

                            self.submitButton.classList.add('downloaded');
                            self.submitButton.querySelector('.trigger').classList.add('drawn');
                            setTimeout(function () {
                                document.location.reload();
                            }, 1000);
                        } else {
                            //Enable submit button again
                            self.submitButton.disabled = false;
                            self.showGlobalError(response.message, response.reservationId);
                        }
                    } else {
                        //Enable submit button again
                        self.submitButton.disabled = false;
                        self.showGlobalError('Speichern fehlgeschlagen');
                    }
                },
                function (data) {
                    //Enable submit button again
                    self.submitButton.disabled = false;
                    self.showGlobalError('Speichern fehlgeschlagen: ' + data);
                }
            );
        });
    };

    /**
     * initialized collapse elements and add hide and show event listeners
     *
     * @returns {void}
     */
    WizardAction.prototype.initializeCollapseElements = function () {
        const self = this;
        self.accordion.querySelectorAll('[data-toggle="collapse"]').forEach(function (collapseItem) {
            self.initializeCollapseElement(collapseItem);
        });

        //Open first card when creating a new reservation
        if (self.mode === 'new') {
            setTimeout(function () {
                self.accordion.querySelectorAll('[data-toggle="collapse"]')[0].click();
            }, 1000);
        }
    };

    /**
     * initialized collapse elements and add hide and show event listeners
     *
     * @returns {void}
     */
    WizardAction.prototype.initializeCollapseElement = function (element) {
        const self = this;
        new Collapse(element, {
            parent: self.accordion
        });
        self.accordion.querySelector(element.getAttribute('href')).addEventListener('show.bs.collapse', function (e) {
            var card = e.target.closest('.card');
            var idx = self.getIndexOfCard(card);

            card.classList.add('card-active');
            self.steps[idx].initialize();
        });
        self.accordion.querySelector(element.getAttribute('href')).addEventListener('hide.bs.collapse', function (e) {
            var card = e.target.closest('.card');
            var idx = self.getIndexOfCard(card);


            if (self.steps[idx].hasData()) {
                self.steps[idx].updateHasDataHeader();
                self.steps[idx].showHasDataHeader();
            }

            var valid = self.steps[idx].validateStep();

            if (valid) {

                self.steps[idx].preSubmit(function () {

                    card.classList.remove('card-error');
                    card.classList.remove('card-active');
                    var nextStep = card.nextElementSibling;
                    if (nextStep) {
                        nextStep.querySelector('[data-toggle="collapse"]').click();
                    }
                });
            } else {
                card.classList.add('card-error');
            }

        });
    };

    /**
     * validates all steps and activates submit button if all valid
     *
     * @returns {void}
     */
    WizardAction.prototype.toggleStateOfSubmitButton = function () {
        const self = this;

        //Initialize actions
        var allValid = true;
        self.steps.forEach(function (step) {
            if (!step.getValidState()) {
                allValid = false;
            }
        });

        if (allValid) {
            self.submitButtonDisabled.classList.add('d-none');
            self.submitButton.classList.remove('d-none');
        } else {
            self.submitButton.classList.add('d-none');
            self.submitButtonDisabled.classList.remove('d-none');
        }
    };

    /**
     * initializes JS for all steps
     *
     * @returns {void}
     */
    WizardAction.prototype.initializeSteps = function () {
        const self = this;
        self.steps = [];

        //Initialize actions
        var promises = [];
        var position = 0;
        self.accordion.querySelectorAll(':scope > *').forEach(function (step) {
            promises.push(new Promise(
                function (resolve, reject) {
                    self.initializeStep(step, position, function (status) {
                        if (status === 0) {
                            resolve();
                        } else {
                            reject();
                        }
                    });
                })
            );
            position++;
        });

        Promise.all(promises).then(function () {
            self.dispatchEvent('allStepsInitialized');
            self.isInitialLoading = false;
        });
    };

    /**
     * Dynamically removes a step
     *
     * @param {int} index
     * @returns {void}
     */
    WizardAction.prototype.removeStep = function (index) {
        const self = this;

        //Remove step
        self.steps.splice(index, 1);

    };

    /**
     * initializes JS for specific step
     *
     * @param {object} stepElement
     * @param {int} position Optional: position of the step
     * @param {function} callback function
     *
     * @returns {void}
     */
    WizardAction.prototype.initializeStep = function (stepElement, position, callback) {
        const self = this;
        var actionName = stepElement.dataset.stepaction;
        var action = null;
        switch (actionName) {
            case 'date-selection':
                action = new Sitepackage.Plugin.Reservation.WizardStepDateSelectionAction(self, self.container, stepElement);
                break;
            case 'ticket-selection':
                action = new Sitepackage.Plugin.Reservation.WizardStepTicketSelectionAction(self, self.container, stepElement);
                break;
            case 'group-info':
                action = new Sitepackage.Plugin.Reservation.WizardStepGroupInfoAction(self, self.container, stepElement);
                break;
            case 'reservation-info':
                action = new Sitepackage.Plugin.Reservation.WizardStepReservationInfoAction(self, self.container, stepElement);
                break;
        }

        if (action) {
            action.initialize(function () {
                self.steps.splice(position, 0, action);
                var nextButton = stepElement.querySelector('.btn-next');
                if (nextButton) {
                    nextButton.addEventListener('click', function (event) {
                        var button = event.target;
                        var card = button.closest('.card');

                        //Trigger click on header to call hide event which does validation and pre submit tasks
                        card.querySelector('[data-toggle="collapse"]').click();
                        return false;
                    });
                }

                self.dispatchEvent('stepInitialized', [position, action]);
                if (callback && typeof callback === 'function') {
                    callback(0);
                }
            });

        } else {
            if (console) {
                console.error('Invalid action: ' + actionName);
            }
            if (callback && typeof callback === 'function') {
                callback(1);
            }
        }


    };

    /**
     * show voucher download info
     *
     * @returns {void}
     */
    WizardAction.prototype.showVoucherInfo = function () {
        const self = this;
        var alertBox = document.getElementById('modal-reservation').querySelector('.voucher-alert');
        if (!self.isInitialLoading && self.mode !== 'new') {
            alertBox.classList.add('show');
        } else {
            alertBox.classList.remove('show');
        }
    };

    /**
     * Returns current reservation values.
     *
     *
     * @returns {json}
     */
    WizardAction.prototype.getCurrentValues = function () {
        if (!this.currentValues) {
            this.currentValues = {};
        }
        return this.currentValues;
    };

    /**
     * sets all current reservation values.
     *
     * @param {json} values
     * @returns {json}
     */
    WizardAction.prototype.setCurrentValues = function (values) {
        if (this.currentValues !== values) {
            this.currentValues = values;
        }
    };


    /**
     * gets value for a key in current reservation values.
     *
     * @param {string} key
     * @returns {mixed} value
     */
    WizardAction.prototype.getCurrentValue = function (key) {
        if (!this.currentValues) {
            this.currentValues = {};
        }
        return this.currentValues[key];
    };

    /**
     * sets a key in current reservation values.
     *
     * @param {string} key
     * @param {mixed} value
     * @returns {json}
     */
    WizardAction.prototype.setCurrentValue = function (key, value) {
        var currentValuesClone = JSON.parse(JSON.stringify(this.currentValues));

        //Unset values unrelated to voucher generation
        currentValuesClone['sendEmail'] = '';
        currentValuesClone['email'] = '';
        var valuesBefore = JSON.stringify(currentValuesClone);
        if (!this.currentValues) {
            this.currentValues = {};
        }
        if (this.currentValues[key] !== value) {
            this.currentValues[key] = value;
        }
        currentValuesClone = JSON.parse(JSON.stringify(this.currentValues));
        //Unset values unrelated to voucher generation
        currentValuesClone['sendEmail'] = '';
        currentValuesClone['email'] = '';
        var valuesAfter = JSON.stringify(currentValuesClone);
        if (valuesBefore !== valuesAfter) {
            this.showVoucherInfo();
        }

    };

    /**
     * Notifies the given event.
     *
     * @param {string} event Name of the event to notify
     * @param {Object} data (Optional) Data to pass to the listeners (defaults to nothing)
     *
     * @returns {void}
     */
    WizardAction.prototype.dispatchEvent = function (event, data) {
        if (!this.listener.hasOwnProperty(event)) {
            throw new Error('Event "' + event + '" does not exist.');
        }

        this.listener[event].forEach(function (callback) {
            callback(data);
        });
    };

    /**
     * Shows global error message, e.g. when saving failed
     *
     * @param {string} message
     * @param reservationId
     * @returns {void}
     */
    WizardAction.prototype.showGlobalError = function (message, reservationId) {
        const self = this;

        self.errorContainer.innerHTML = message;
        self.errorContainer.classList.remove('d-none');
        self.errorContainer.classList.remove('shake');


        anime({
            targets: document.getElementById('modal-reservation'),
            scrollTop: 0,
            duration: 500,
            easing: 'easeInOutQuad',
            complete: function () {
                self.errorContainer.classList.add('shake');
            }
        });

        //Set reservation id in case new reservation errored to prevent double saves
        if (reservationId) {
            self.setCurrentValue('reservationId', reservationId);
        }

    };

    /**
     * Shows all error states for the given field with the given message
     *
     * @param {string} field
     * @param {string} message
     * @returns {void}
     */
    WizardAction.prototype.showError = function (field, message) {
        const self = this;

        //Find all elements with data-field-value and add message and error class
        var selector = '[data-field-value="' + field + '"]';
        //Modify selector for timeslot selection steps as they need info about the timeslot ID to be unique
        if (field.indexOf('|') > 0) {
            var parts = field.split('|');
            selector = '[data-timeslot="' + parts[0] + '"] [data-field-value="' + parts[1] + '"]';
        }

        this.accordion.querySelectorAll(selector).forEach(function (item) {

            item.classList.add('card-error-detail');

            //Add error badge if not already added
            if (!item.querySelector('.badge-error')) {
                item.innerHTML += self.errorBadgeTemplate;
            }
            item.querySelector('.badge-error').setAttribute('title', message);

        });

        this.accordion.querySelectorAll('[data-toggle="tooltip"]').forEach(function (tooltip) {
            new Tooltip(tooltip);
        });

    };

    /**
     * Removes all error states for the given field
     *
     * @param {string} field
     * @returns {void}
     */
    WizardAction.prototype.removeError = function (field) {
        const self = this;

        //Find all elements with data-field-value and add message and error class
        var selector = '[data-field-value="' + field + '"]';
        //Modify selector for timeslot selection steps as they need info about the timeslot ID to be unique
        if (field.indexOf('|') > 0) {
            var parts = field.split('|');
            selector = '[data-timeslot="' + parts[0] + '"] [data-field-value="' + parts[1] + '"]';
        }
        this.accordion.querySelectorAll(selector).forEach(function (item) {
            item.classList.remove('card-error-detail');


        });

    };

    return WizardAction;
})();
